(function () {
  'use strict';

  // Sticky buy bar (workbook landing page)
  var bar = document.getElementById('sr-buyBar');
  if (bar) {
    var offer = document.getElementById('offer');
    function onScroll() {
      var y = window.scrollY;
      var pastThreshold = y > 260;
      var pastOffer = offer ? offer.getBoundingClientRect().bottom < 0 : false;
      bar.classList.toggle('sr-show', pastThreshold && !pastOffer);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();